/**
* Configuration object to be passed to MSAL instance on creation.
* For a full list of MSAL.js configuration parameters, visit:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
*/

import { Configuration, BrowserCacheLocation } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENTID ?? "",
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANTID}/`,
        redirectUri: window.location.origin + '/auth'
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Persists across browser sessions
        storeAuthStateInCookie: false, // Not needed for modern browsers (Edge/Chrome)
    }
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [process.env.REACT_APP_MSAL_TOKENSCOPE ?? ""]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};